import PropTypes from 'prop-types'
import React, { createRef } from 'react'
import { connect } from 'react-redux'
import focusable from '../../components/Focusable/Focusable'
import FocusableButton from '../../components/FocusableButton/FocusableButton'
import tts from '../../../src/lib/TTS'
import { getContentSets } from './contentSets'
import ContentsSwitcher from '../../../../shared/components/ContentsSwitcher/ContentsSwitcher'
import ProgressBar from '../../components/ProgressBar'
import StationPassportTitle from '../../components/StationPassportTitle/StationPassportTitle'
import googleAnalytics4 from '../../lib/googleAnalytics'
import { withRouter } from '../../../../shared/components/WithRouter/WithRouter'

class LearnMoreScreen extends React.Component {
  constructor(props) {
    super(props)
    this.becomeAMemberButtonRef = createRef()
    this.backwardButtonRef = createRef()
    this.forwardButtonRef = createRef()
    this.contentSets = getContentSets(props.stationTitle)
    this.navigationHistory = []
    this.state = {
      currentContentIndex: 0,
      justMounted: true,
      justFocusedForwardBtn: false,
      justFocusedBackwardBtn: false,
      historyHandled: false,
    }
  }

  componentDidMount() {
    setTimeout(() => this.becomeAMemberButtonRef.current?.setFocus(), 500)
    googleAnalytics4.sendPageViewEvent('Passport Learn More')
  }

  componentDidUpdate(_, prevState) {
    if (prevState.currentContentIndex !== this.state.currentContentIndex) {
      if (!this.state.historyHandled) {
        this.navigationHistory.unshift(prevState.currentContentIndex)
      }
      if ([0, 1].includes(this.state.currentContentIndex)) {
        this.setState({ justFocusedForwardBtn: true })
        this.forwardButtonRef.current?.setFocus()
      } else if (
        this.state.currentContentIndex ===
        this.contentSets.length - 1
      ) {
        this.setState({ justFocusedBackwardBtn: true })
        this.backwardButtonRef.current?.setFocus()
      }

      this.setState({ historyHandled: false })
    }
  }

  onKeyEvent(key) {
    switch (key) {
      case 'LEFT':
        return this.handleLeftKey()
      case 'RIGHT':
        return this.handleRightKey()
      case 'BACK':
        tts.stop()
        if (this.navigationHistory.length > 0) {
          this.setState({
            currentContentIndex: this.navigationHistory.shift(),
            historyHandled: true,
          })

          if (this.navigationHistory.length === 0) {
            tts.addTextToRead(
              `${
                this.contentSets[this.state.currentContentIndex].tts
              } ..... Focused on Forward button`
            )
          }
        } else {
          this.props.router.navigate(-1)
        }
        return true
      default:
        return false
    }
  }

  handleLeftKey() {
    switch (window.focusedComponent.componentType) {
      case 'forwardButton':
        if (this.state.currentContentIndex === 0) {
          this.becomeAMemberButtonRef.current?.setFocus()
        } else {
          this.backwardButtonRef.current?.setFocus()
        }
        return true
      case 'backwardButton':
        this.becomeAMemberButtonRef.current?.setFocus()
        return true
      default:
        return false
    }
  }

  handleRightKey() {
    switch (window.focusedComponent.componentType) {
      case 'becomeAMember':
        if (this.state.currentContentIndex === 0) {
          this.forwardButtonRef.current?.setFocus()
        } else {
          this.backwardButtonRef.current?.setFocus()
        }
        return true
      case 'backwardButton':
        if (this.state.currentContentIndex !== 2) {
          this.forwardButtonRef.current?.setFocus()
        }
        return true
      default:
        return false
    }
  }

  handleBecomeAMemberBtnClick = () => {
    tts.stop()
    this.props.router.navigate('/in-app-donations')
  }

  handleBackwardBtnClick = () => {
    if (this.state.currentContentIndex > 0) {
      tts.stop()
      tts.addTextToRead(
        `${
          this.contentSets[this.state.currentContentIndex - 1].tts
        } ..... Focused on backward button`
      )
      this.setState({ currentContentIndex: this.state.currentContentIndex - 1 })
    }
  }

  handleForwardBtnClick = () => {
    if (this.state.currentContentIndex < this.contentSets.length - 1) {
      tts.stop()
      tts.addTextToRead(
        `${
          this.contentSets[this.state.currentContentIndex + 1].tts
        } ..... Focused on forward button`
      )
      this.setState({ currentContentIndex: this.state.currentContentIndex + 1 })
    }
  }

  handleBecomeAMemberBtnFocused = () => {
    tts.stop()
    if (this.state.justMounted) {
      tts.addTextToRead(
        `${this.props.stationTitle} Passport ${this.contentSets[0].tts} ..... Focused on become a member button`
      )
      this.setState({ justMounted: false })
    } else {
      tts.addTextToRead('Focused on become a member button')
    }
  }

  handleBackwardBtnFocused = () => {
    tts.stop()
    if (this.state.justFocusedBackwardBtn) {
      tts.addTextToRead(
        `${
          this.contentSets[this.contentSets.length - 1].tts
        } ..... Focused on backward button`
      )
      this.setState({ justFocusedBackwardBtn: false })
    } else {
      tts.addTextToRead('Focused on backward button')
    }
  }

  handleForwardBtnFocused = () => {
    tts.stop()
    if (this.state.justFocusedForwardBtn) {
      tts.addTextToRead(
        `${
          this.contentSets[this.state.currentContentIndex].tts
        } ..... Focused on Forward button`
      )
      this.setState({ justFocusedForwardBtn: false })
    } else {
      tts.addTextToRead('Focused on forward button')
    }
  }

  render() {
    const { currentContentIndex } = this.state
    return (
      <div className="learn-more">
        <StationPassportTitle
          stationTitle={this.props.stationTitle}
          className="learn-more__station-title"
        />
        <ContentsSwitcher
          contents={this.contentSets}
          currentContentIndex={currentContentIndex}
          className="learn-more__content"
          contentKey="key"
        >
          {(content) => (
            <>
              <div className="learn-more__content-left">
                <h1 className="learn-more__content-title">{content.title}</h1>
                <div className="learn-more__progress">
                  <ProgressBar
                    total={this.contentSets.length}
                    current={currentContentIndex + 1}
                    fullWidth={true}
                    className="learn-more__progress-bar"
                  />
                </div>
                <p className="learn-more__content-description">
                  {content.description}
                </p>
              </div>
              <div className="learn-more__background-image-container">
                <img
                  className="learn-more__background-image"
                  src={content.img}
                />
              </div>
            </>
          )}
        </ContentsSwitcher>
        <div className="learn-more__controls">
          <div>
            <FocusableButton
              label="Become A Member"
              parent={this}
              componentType="becomeAMember"
              onClick={this.handleBecomeAMemberBtnClick}
              onFocused={this.handleBecomeAMemberBtnFocused}
              className="learn-more__button learn-more__become-a-member-btn"
              ref={this.becomeAMemberButtonRef}
            >
              <div className="learn-more__become-a-member-txt">
                Become A Member
              </div>
            </FocusableButton>
          </div>
          <div className="learn-more__navigation-buttons">
            <FocusableButton
              label="Backward"
              parent={this}
              componentType="backwardButton"
              onClick={this.handleBackwardBtnClick}
              onFocused={this.handleBackwardBtnFocused}
              disabled={this.state.currentContentIndex === 0}
              className="learn-more__button"
              ref={this.backwardButtonRef}
            >
              <div className="learn-more__backward-arrow"></div>
            </FocusableButton>
            <FocusableButton
              label="Forward"
              parent={this}
              onClick={this.handleForwardBtnClick}
              onFocused={this.handleForwardBtnFocused}
              disabled={this.state.currentContentIndex === 2}
              className="learn-more__button"
              componentType="forwardButton"
              ref={this.forwardButtonRef}
            >
              <div className="learn-more__forward-arrow"></div>
            </FocusableButton>
          </div>
        </div>
      </div>
    )
  }
}

LearnMoreScreen.propTypes = {
  stationTitle: PropTypes.string,
  router: PropTypes.shape({
    navigate: PropTypes.func,
  }),
}

const mapStateToProps = (state) => {
  return {
    stationTitle: state?.station?.short_common_name,
  }
}

export default connect(
  mapStateToProps,
  null,
  null
)(withRouter(focusable(LearnMoreScreen)))
